var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "60px",
    height: "60px",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FE9901",
    d: "M14.25 10.71L11.57 8l2.26-2.26a2.49 2.49 0 0 0 0-3.53a2.5 2.5 0 0 0-3.53 0l-.89.88L8 4.5L5.28 1.75a1.26 1.26 0 0 0-1.76 0L1.75 3.52a1.25 1.25 0 0 0 0 1.77L4.5 8l-.22.22l-.89.88l-1.75 3.66a1.25 1.25 0 0 0 1.67 1.67l3.62-1.75l.49-.49l.39-.39l.19-.23l2.68 2.68a1.26 1.26 0 0 0 1.76 0l1.77-1.77a1.25 1.25 0 0 0 .04-1.77m-2.19-8a1.27 1.27 0 0 1 .89.36a1.25 1.25 0 0 1 0 1.77l-1.77-1.72a1.27 1.27 0 0 1 .88-.36zM2.63 4.4L4.4 2.64l.82.82l-.87.88l.88.88l.88-.88l1 1l-1.73 1.81zm.13 8.91l1.57-3.23L6 11.74zm4.17-2.4L5.16 9.14L10.3 4l1.76 1.76zm4.67 2.45l-2.68-2.67l1.77-1.77l.93.93l-.88.88l.88.89l.89-.89l.86.87z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.a9d939f76948cc74c4e8adb6ddbe5df5.svg";
export { ForwardRef as ReactComponent };